// extracted by mini-css-extract-plugin
module.exports = {"button":"MenuButton_button__qTfPM button-reset p-4","icon":"MenuButton_icon__KlJRY"};